import React from 'react';

/**
 * حاجز أخطاء على مستوى التطبيق.
 *
 * بدونه كان أي استثناء أثناء الرندر يُفرغ الشجرة كاملة ويترك المستخدم
 * أمام شاشة سوداء بلا تفسير ولا مخرج.
 */
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, stack: '' };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('خطأ غير متوقع في الواجهة:', error, info?.componentStack);
    this.setState({ stack: info?.componentStack ?? '' });
  }

  handleReload = () => {
    window.location.reload();
  };

  handleReset = () => {
    // مخرج أخير: بيانات محلية تالفة قد تمنع الإقلاع في كل مرة
    try {
      Object.keys(localStorage)
        .filter((k) => k.startsWith('moslam_'))
        .forEach((k) => localStorage.removeItem(k));
    } catch {
      // التخزين محظور — لا شيء نفعله
    }
    window.location.reload();
  };

  render() {
    if (!this.state.error) return this.props.children;

    // الرموز اللونية معرّفة على ‎:root‎ في index.css، فتعمل هذه الشاشة
    // حتى لو انهار التطبيق قبل تطبيق الثيم.
    return (
      <div
        className="min-h-screen bg-paper text-ink flex items-center justify-center p-6"
        dir="rtl"
      >
        <div className="w-full max-w-sm bg-surface border border-line rounded-xl p-6 text-center space-y-4 shadow-lift">
          <div className="w-12 h-12 rounded-md bg-live/10 text-live flex items-center justify-center mx-auto text-xl">
            ⚠
          </div>

          <div className="space-y-1.5">
            <h1 className="text-base font-semibold text-ink">حدث خطأ غير متوقع</h1>
            <p className="text-xs text-ink-muted leading-relaxed">
              نعتذر عن ذلك. أعد تحميل التطبيق للمتابعة.
            </p>
          </div>

          <div className="space-y-2">
            <button
              onClick={this.handleReload}
              className="btn-primary w-full h-11 rounded-md text-sm font-semibold"
            >
              إعادة تحميل التطبيق
            </button>
            <button
              onClick={this.handleReset}
              className="w-full h-10 rounded-md border border-line bg-surface-alt text-xs font-medium text-ink-muted hover:text-ink transition-colors"
            >
              إعادة تعيين الإعدادات المحفوظة
            </button>
          </div>

          {/*
            التفاصيل كانت تظهر في وضع التطوير وحده، فكان من يصادف الخطأ
            في الإنتاج — وهو وحده من يستطيع إعادة إنتاجه — لا يملك ما
            يُبلّغ به. فصارت مطويّة: لا تُفزع أحداً، ويجدها من يحتاجها.
          */}
          <details className="text-right">
            <summary className="text-2xs text-ink-muted cursor-pointer select-none">
              تفاصيل تقنية
            </summary>
            <pre
              className="mt-2 text-2xs text-live bg-surface-alt border border-line rounded-md p-2.5 overflow-auto max-h-48 whitespace-pre-wrap"
              dir="ltr"
            >
              {[
                this.state.error?.name,
                this.state.error?.message,
                this.state.error?.stack,
                this.state.stack,
              ]
                .filter(Boolean)
                .join('\n')}
            </pre>
          </details>
        </div>
      </div>
    );
  }
}
